// extracted by mini-css-extract-plugin
module.exports = {"cardAct":"activityCard_cardAct__bglNw"};